/* eslint-disable max-lines, no-undef, react/destructuring-assignment, react/no-unused-state, sort-keys, sort-vars */

import {
  buildFilterQueryString,
  readFilterParamsFromCookie,
  storeFilterParamsInCookie,
  transformKeysToSelectedFilterObjects
} from "../modules/filters_helper";
import {handleFilterClick, setFilters} from "../../../actions";
import EventsAPI from "../../../shared/modules/EventsAPI";
import FilterPills from "./FilterPills";
import Filters from "./Filters";
import PropTypes from "prop-types";
import React from "react";
import SortSelect from "./SortSelect";
import ToolTip from "../../../shared/components/ToolTip";
import _compact from "lodash/compact";
import _isEqual from "lodash/isEqual";
import {connect} from "react-redux";
import {withCookies} from "react-cookie";

class FiltersContainer extends React.Component {

  static propTypes = {
    "categories": PropTypes.array.isRequired,
    "cookies": PropTypes.object.isRequired,
    "customerState": PropTypes.string.isRequired,
    "doFilter": PropTypes.func.isRequired,
    "eligibleForFineJewelry": PropTypes.bool,
    "excludeTrendsFromFilter": PropTypes.bool,
    "filters": PropTypes.array.isRequired,
    "handleFilterClick": PropTypes.func.isRequired,
    "isMobile": PropTypes.bool.isRequired,
    "params": PropTypes.object.isRequired,
    "previewSwapping": PropTypes.bool,
    "productPanelClass": PropTypes.string,
    "requestsNeeded": PropTypes.number.isRequired,
    "selectedFilters": PropTypes.array.isRequired,
    "setFilters": PropTypes.func.isRequired,
    "showClearancePrice": PropTypes.bool.isRequired,
    "showPriceRangeFilters": PropTypes.bool.isRequired,
    "showPromoFilters": PropTypes.bool.isRequired,
    "showTrendFilters": PropTypes.bool.isRequired,
    "sorts": PropTypes.array.isRequired,
    "stickyFilter": PropTypes.object
  };

  static defaultProps = {
    "eligibleForFineJewelry": false,
    "excludeTrendsFromFilter": false,
    "previewSwapping": false,
    "productPanelClass": "default",
    "stickyFilter": {}
  };

  constructor (props) {
    super(props);

    this.state = {
      "showToolTip": true,
      "filtersOpen": false
    };
  }

  componentDidMount = () => {
    this.readInitialFilterParamsAndSyncURLAndCookies();
    setTimeout(() => {
      this.hideToolTip();
    }, 10000);
  }

  componentDidUpdate = (prevProps) => {
    const {selectedFilters, doFilter} = this.props;
    const prevSelectedFilters = prevProps.selectedFilters;

    if (!_isEqual(selectedFilters, prevSelectedFilters)) {
      doFilter();
      const params = this.addFiltersQueryString();
      this.storeFilterParams(params.replace("?", "").split("&"));
    }
  }

  readInitialFilterParamsAndSyncURLAndCookies = () => {
    let params = window.location.search.replace("?", "").split("&");
    if (_compact(params).length === 0) {
      params = this.readFilterParams();
      if (_compact(params).length > 0) {
        this.addFiltersQueryString(params);
      }
    } else {
      this.storeFilterParams(params);
    }
    if (_compact(params).length > 0) {
      this.applyFiltersFromParams(params);
    }
  }

  addFiltersQueryString = (filterKeys) => {
    const {selectedFilters} = this.props;

    const filterQueryString = buildFilterQueryString(selectedFilters, filterKeys);
    window.history.replaceState(location.pathname, "", `${filterQueryString}`);
    return filterQueryString;
  }

  storeFilterParams = (filterParams) => {
    const {cookies} = this.props;
    storeFilterParamsInCookie(cookies, filterParams);
  }

  readFilterParams = () => {
    const {cookies} = this.props;
    return readFilterParamsFromCookie(cookies);
  }

  applyFiltersFromParams = (params) => {
    const {filters, setFilters, sorts} = this.props; // eslint-disable-line no-shadow

    const cleanedUpParams = params.map((param) => {
      if (param.charAt(param.length - 1) === "=") {
        return param.slice(0, -1);
      }
      return param;
    });

    const selected = transformKeysToSelectedFilterObjects(cleanedUpParams, filters, sorts);
    setFilters(selected);
  }

  handleFilterClickEvent = (filterName) => {
    const {cookies} = this.props;
    const selected = !this.props.selectedFilters.some(({displayName}) => displayName === filterName);
    if (selected) {
      EventsAPI.trackUserEvent(`clicked_${filterName}_filter`, "", cookies.get("anonymous_contact_id"));
    }
  }

  handleClick = (event) => {
    const target = event.currentTarget;
    const key = target.id;
    const displayName = target.title;
    const showIfSelected = target.attributes.showifselected ? target.attributes.showifselected.value : "";
    const {filters, handleFilterClick} = this.props; // eslint-disable-line no-shadow
    const filterFound = filters.find(filter => filter.key.includes(key.split("-")[0]));
    const {defaultHide} = filterFound;
    const {singleSelection} = key.split("-").length === 3
      ? filterFound.selections.find(subFilter => subFilter.key.includes(`${key.split("-")[0]}-${key.split("-")[1]}`))
      : filterFound;

    this.handleFilterClickEvent(displayName);

    handleFilterClick({
      displayName,
      key,
      singleSelection,
      showIfSelected,
      defaultHide
    });
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleClick();
    }
  }

  sort = (displayName) => {
    const key = `sort-${displayName.toLowerCase().replace(/ /g, "_")}`;
    const {handleFilterClick} = this.props; // eslint-disable-line no-shadow

    handleFilterClick({
      displayName,
      key,
      "singleSelection": true,
      "showIfSelected": ""
    });
  }

  closeAllFilters = () => {
    const {filtersOpen} = this.state;

    if (!filtersOpen) {
      $(".selections").css("display", "none");
      $(".type-title .glyphicon").removeClass("glyphicon-minus").addClass("glyphicon-plus");
      $("html").removeClass("no-scroll");
    }
  }


  hideToolTip = () => {
    const {showToolTip} = this.state;

    if (showToolTip) {
      this.setState({"showToolTip": false});
    }
  }

  toggleMobileFilters = (event) => {
    const target = event.currentTarget;
    const querySelector = target.attributes["data-target"].value;
    const {filtersOpen} = this.state;
    const elem = document.body;

    if (filtersOpen) {
      elem.classList.remove("adjust-z-index");
      elem.style.setProperty("overflow", "visible");
    } else {
      elem.classList.add("adjust-z-index");
      elem.style.setProperty("overflow", "hidden");
    }

    $(querySelector).animate(
      {"width": "toggle"},
      {
        "complete": () => {
          this.hideToolTip();
          this.setState(
            {"filtersOpen": !filtersOpen},
            this.closeAllFilters
          );
        }
      }
    );
  }

  renderFiltersHeader = () => {
    const {
      doFilter,
      filters,
      isMobile,
      previewSwapping,
      sorts
    } = this.props;

    return (
      <div
        className={`wishlist-header pt24 pb8${this.stickyClass()}`}
      >
        <FilterPills
          doFilter={doFilter}
          filters={filters}
          handleClick={this.handleClick}
          isMobile={isMobile}
        />
        <SortSelect
          previewSwapping={previewSwapping}
          sort={this.sort}
          sorts={sorts}
        />
      </div>
    );
  }

  stickyClass = () => {
    const {customerState, requestsNeeded, params} = this.props;
    return requestsNeeded <= 0 || customerState === "new-user" || params.controller === "roxy/shop"
      ? " no-wishlist-banner"
      : " wishlist-banner";
  }

  render () {
    const {
      categories,
      doFilter,
      excludeTrendsFromFilter,
      isMobile,
      filters,
      params,
      previewSwapping,
      productPanelClass,
      showClearancePrice,
      showPriceRangeFilters,
      showPromoFilters,
      showTrendFilters,
      sorts,
      stickyFilter
    } = this.props;
    const {showToolTip} = this.state;
    const filtersMobileClass = isMobile ? " mobile" : " pt24";

    return (
      <React.Fragment>
        {!isMobile && this.renderFiltersHeader() }
        <div
          className={`filters-container text-small averta${filtersMobileClass}${this.stickyClass()}`}
        >
          {isMobile &&
            <div>
              {!previewSwapping &&
                <FilterPills
                  doFilter={doFilter}
                  filters={filters}
                  handleClick={this.handleClick}
                  isMobile={isMobile}
                />}
            </div>
          }
          <Filters
            categories={categories}
            doFilter={doFilter}
            excludeTrendsFromFilter={excludeTrendsFromFilter}
            filters={filters}
            handleClick={this.handleClick}
            handleKeyDown={this.handleKeyDown}
            handleTooltipClose={this.hideToolTip}
            isMobile={isMobile}
            params={params}
            previewSwapping={previewSwapping}
            productPanelClass={productPanelClass}
            showClearancePrice={showClearancePrice}
            showPriceRangeFilters={showPriceRangeFilters}
            showPromoFilters={showPromoFilters}
            showToolTip={showToolTip}
            showTrendFilters={showTrendFilters}
            sort={this.sort}
            sorts={sorts}
            stickyFilter={stickyFilter}
            toggleMobileFilters={this.toggleMobileFilters}
          />
        </div>
        {isMobile && previewSwapping &&
          <div className="filter-mobile-tool-tip-container">
            <ToolTip
              arrowPosition="left"
              classes="filter-mobile-tool-tip"
              color="grey"
              content="Click to expand filter options"
              handleTooltipClose={this.hideToolTip}
              showToolTip={showToolTip}
            />
          </div>
        }
      </React.Fragment>
    );
  }
}

const mapStoreToProps = store => ({"selectedFilters": store.selectedFilters || []});

export default withCookies(connect(
  mapStoreToProps,
  {
    handleFilterClick,
    setFilters
  }
)(FiltersContainer));
